<template>
  <div class="Wdgt-Content-Reactions">
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('like')" 
      :count="get_reactionCount('like')" 
      :isActive="get_isActive('like')"
      :icon="ICON_LIKE" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('smile')" 
      :count="get_reactionCount('smile')" 
      :isActive="get_isActive('smile')"
      :icon="ICON_SMILE" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('fire')" 
      :count="get_reactionCount('fire')" 
      :isActive="get_isActive('fire')"
      :icon="ICON_FIRE" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('think')" 
      :count="get_reactionCount('think')" 
      :isActive="get_isActive('think')"
      :icon="ICON_THINK" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('scream')" 
      :count="get_reactionCount('scream')" 
      :isActive="get_isActive('scream')"
      :icon="ICON_SCREAM" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('cry')" 
      :count="get_reactionCount('cry')" 
      :isActive="get_isActive('cry')"
      :icon="ICON_CRY" 
    />
    <ButtonReaction 
      class="Wdgt-Content-Reactions__btn" 
      @click="handleReactionClick('dislike')" 
      :count="get_reactionCount('dislike')"
      :isActive="get_isActive('dislike')" 
      :icon="ICON_DISLIKE" 
    />
  </div>
</template>

<script setup>
  import { defineProps, computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { debounce } from 'lodash';
  import { changeRaction } from './api/changeRaction.js';
  import { loadNewReactions } from './api/loadNewReactions.js';
  import { REACTIONS_KEYS } from '@shared/constants/reactions/reactions_names.js';
  //-------------------------------------
  import ButtonReaction from '@ui/Buttons/ButtonReaction/ButtonReaction.vue';
  //-------------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //-------------------------------------
  const ID = props.postId || props.signalId;
  const DEBOUNCE_TIME = 400;

  const ICON_LIKE = require('@shared/images/reactions/like.png');
  const ICON_SMILE = require('@shared/images/reactions/smile.png');
  const ICON_THINK = require('@shared/images/reactions/think.png');
  const ICON_SCREAM = require('@shared/images/reactions/scream.png');
  const ICON_CRY = require('@shared/images/reactions/cry.png');
  const ICON_DISLIKE = require('@shared/images/reactions/dislike.png');
  const ICON_FIRE = require('@shared/images/reactions/fire.png');
  //-------------------------------------
  const lastFixedReaction = ref(0);
  const currentChooseReaction = ref(0);
  //-------------------------------------
  onMounted(async () => {
    await toLoadNewReactions();
    initChoosenReaction();
  })
  //-------------------------------------
  //Получить объект, к которому относятся реакции
  const get_data = computed(() => {
    if(props.postId){
      return store.state.ContentSystem.Alpha.list[ID] || store.state.ContentSystem.Infonoise.list[ID];
    }else if(props.signalId){
      return store.state.OldSignals.data[ID];  
    }
  });
  //Получить объект реакций
  const get_reactions = computed(() => get_data.value.reactions.reactions_values);
  //Проверяем, что действие совершенное пользователем отличается от зафиксированного прошлого действия
  const get_isNewServerAction = computed(() => currentChooseReaction.value !== lastFixedReaction.value);
  //Получить значение счетчика реакции
  const get_reactionCount = (name) => { 
    return get_reactions.value[REACTIONS_KEYS[name]];
  }
  //Активна ли эта реакция пользователем?
  const get_isActive = (name) => {
    return currentChooseReaction.value == REACTIONS_KEYS[name];
  }
  //У пользователя оплачен аккаунт?
  const get_isPaidContent = computed(() => store.getters['UserSystem/hasPaidAccess']);
  //-------------------------------------
  //Инициализировать состояние выбранной пользователем реакиии
  const initChoosenReaction = () => {
    lastFixedReaction.value = get_data.value.reactions.is_mine;
    currentChooseReaction.value = get_data.value.reactions.is_mine;
  }
  //Подгрузить информацию об изменениях в реакциях
  const toLoadNewReactions = async () => {
    const data = await loadNewReactions({ content_type: get_data.value.content_type, object_id: ID });
    if(!data.reactions[ID]) return;
    if(props.postId){
      const areaName = store.state.ContentSystem.Alpha.list[ID] ? 'Alpha' : 'Infonoise';
      store.commit(`ContentSystem/${areaName}/toChangeReactions`, {object_id: ID, reactions: data.reactions[ID]});
    }else if(props.signalId){
      store.commit(`OldSignals/CHANGE_REACTIONS`, {object_id: ID, reactions: data.reactions[ID]});
    }
  }
  //Организую список действий при клике по кнопке реакций 
  const handleReactionClick = (name) => {
    if(!get_isPaidContent.value) return;
    const number = REACTIONS_KEYS[name];
    chooseMethodUpdatingReaction(number);
    updateCurrentReactionStates(number);
    debounceSendDataToServer();
  };
  //Запуск процесса обновления реакции, вызывается после задержки действий пользователя
  const debounceSendDataToServer = debounce(() => { sendDataToServer(); }, DEBOUNCE_TIME);
  //Отправляем данные на сервер
  const sendDataToServer = async () => {
    if(get_isNewServerAction.value){
      const fixedReactionNumber = (currentChooseReaction.value !== 0) ? currentChooseReaction.value : lastFixedReaction.value;
      fixedStateInPost();
      const data = { reaction: fixedReactionNumber, content_type: get_data.value.content_type, object_id: ID };
      await changeRaction(data);
    }
  };
  //Обновить состояние реакций в посте
  const fixedStateInPost = () => {
    lastFixedReaction.value = currentChooseReaction.value;
    get_data.value.reactions.is_mine = currentChooseReaction.value;
  }
  //Определяем сценрий изменения счетчика
  const chooseMethodUpdatingReaction = (number) => {
    if(currentChooseReaction.value !== 0 && checkIsActiveTheReaction(number)) 
      removeReaction(number);
    else if(currentChooseReaction.value === 0 && number !== 0) 
      addReaction(number);
    else 
      updateReaction(number);
  };
  //Проверяем, активна ли реакция или нет
  const checkIsActiveTheReaction = (number) => { 
    return parseInt(currentChooseReaction.value) === parseInt(number);
  };
  //Добавить реакцию, если ранее ничего не было выбрано
  const addReaction = (number) => {
    get_reactions.value[number] = get_reactions.value[number] + 1;
  };
  //Обновить реакции
  const updateReaction = (number) => {
    get_reactions.value[number] = get_reactions.value[number] + 1;
    get_reactions.value[currentChooseReaction.value] = get_reactions.value[currentChooseReaction.value] - 1;
  };
  //Убрать выбранную реакцию
  const removeReaction = (number) => {
    get_reactions.value[number] = get_reactions.value[number] - 1;
  }
  //Обвновляем выбранную реакцию
  const updateCurrentReactionStates = (number) => {
    currentChooseReaction.value = checkIsActiveTheReaction(number) ? 0 : number;
  }
</script>

<style lang="scss">
  @import './styles/_styles';
</style>